import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Text from '../../Text/Text';
import { setCreateNewOrderData } from '../../../thunks/coilovers/orders/createNewOrder';
import StepperNavigationBtn from './StepperNavigationBtn';
import CustomSelect from '../../Select/CustomSelect';
import { urgencyTypes } from '../newOrderStepperData';
import Input from '../../Input/Input';
import { coOrderAssemblyTypeList } from '../../../constants/coOrderAssemblyType';

const OrderMarketplaceForm = () => {
  const dispatch = useDispatch();
  const {
    createNewOrderData: {
      orderAssemblyType,
      urgencyType,
      orderNotes,
      soldDate,
      marketplace,
      totalPrice,
    },
  } = useSelector((state) => ({
    createNewOrderData: state.createNewOrder?.data
  }), shallowEqual);

  const utcDate = new Date()
    .toISOString()
    .slice(0, 19)
    .replace('T', ' ');

  return (
    <div className="flex flex-col flex-1">
      <div className="pb-[50px]">
        <Text text="Order Details" textStyle="text-[20px] text-[#252F4A] mb-[6px]" />
      </div>
      <div>
        <div className="mb-[30px]">
          <Text
            text="Type"
            textStyle="text-[#252F4A] text-[14px]"
            styleContainer="mb-[10px]"
          />
          <CustomSelect
            options={coOrderAssemblyTypeList}
            value={[orderAssemblyType]}
            isMulti={false}
            onChange={(data) => dispatch(setCreateNewOrderData({ orderAssemblyType: data }))}
            containerStyle={{
              paddingTop: 13,
              paddingBottom: 13,
              paddingLeft: 26,
              paddingRight: 26,
              fontSize: 16
            }}
          />
        </div>
        <div className="mb-[30px]">
          <div className="flex flex-row gap-[20px]">
            <div className="flex1">
              <Text
                text="Sold date"
                textStyle="text-[#252F4A] text-[14px]"
                styleContainer="mb-[10px]"
              />
              <Input
                type="text"
                name="sold_date"
                value={marketplace === 'ebay' ? utcDate : soldDate}
                placeholder="Sold date"
                onChange={() => {}}
                disabled
              />
            </div>
            <div className="flex1">
              <Text
                text="Total price"
                textStyle="text-[#252F4A] text-[14px]"
                styleContainer="mb-[10px]"
              />
              <Input
                type="number"
                name="total_price"
                value={totalPrice}
                placeholder="Total price"
                disabled
                onChange={() => {}}
              />
            </div>
          </div>
        </div>
        <div className="mb-[30px]">
          <Text
            text="Marketplace"
            textStyle="text-[#252F4A] text-[14px]"
            styleContainer="mb-[10px]"
          />
          <div className="flex flex-row gap-[20px]">
            {urgencyTypes?.map(({ name, id }) => (
              <div
                role="presentation"
                onClick={() => dispatch(setCreateNewOrderData({ urgencyType: name }))}
                key={id}
                className={`cursor-pointer p-[14px] border border-dashed border-[#DBDFE9] rounded-[10px]
                text-[16px] text-center flex-1 flex items-center justify-center
                ${urgencyType === name ? 'border-[#3E97FF] bg-[#f1faff] text-[#3E97FF]' : ''}`}
              >
                {name}
              </div>
            ))}
          </div>
        </div>
        <div className="mb-[30px]">
          <Text
            text="Notes"
            textStyle="text-[#252F4A] text-[14px]"
            styleContainer="mb-[10px]"
          />
          <Input
            type="text"
            name="order_notes"
            value={orderNotes}
            placeholder="Order notes"
            multiline
            rows={2}
            onChange={({ target: { value } }) => dispatch(setCreateNewOrderData({ orderNotes: value }))}
          />
        </div>

      </div>
      <StepperNavigationBtn next="product" prev="marketplace" />
    </div>
  );
};

export default OrderMarketplaceForm;
